import { render, staticRenderFns } from "./healthcare.vue?vue&type=template&id=0c378c1c&"
import script from "./healthcare.vue?vue&type=script&lang=js&"
export * from "./healthcare.vue?vue&type=script&lang=js&"
import style0 from "./healthcare.vue?vue&type=style&index=0&id=0c378c1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports